
class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
document.addEventListener('DOMContentLoaded', function() {
  const priceTooltip = document.querySelectorAll('.js-price-tooltip');

  if (priceTooltip.length > 0) {
    const trigger = priceTooltip;
    const tooltip = document.createElement("div");
    tooltip.classList.add("price-tooltip");
    const gap = 0;

    function getPlacement(trigger) {
      const placements = {
        top: {
          top:
            window.scrollY +
            trigger?.getBoundingClientRect().y -
            tooltip?.offsetHeight -
            gap,
          left:
            trigger?.getBoundingClientRect().x +
            trigger?.getBoundingClientRect().width / 2 -
            tooltip?.offsetWidth / 2,
          inset: "auto auto 0px 0px"
        },
        "top-start": {
          top:
            window.scrollY +
            trigger?.getBoundingClientRect().y -
            tooltip?.offsetHeight -
            gap,
          left: trigger?.getBoundingClientRect().x,
          inset: "auto auto 0px 0px"
        },
        "top-end": {
          top:
            window.scrollY +
            trigger?.getBoundingClientRect().y -
            tooltip?.offsetHeight -
            gap,
          left:
            trigger?.getBoundingClientRect().x +
            trigger?.getBoundingClientRect().width -
            tooltip?.offsetWidth,
          inset: "auto auto 0px 0px"
        },
        bottom: {
          top:
            window.scrollY +
            trigger?.getBoundingClientRect().y +
            trigger?.getBoundingClientRect().height +
            gap,
          left:
            trigger?.getBoundingClientRect().x +
            trigger?.getBoundingClientRect().width / 2 -
            tooltip?.offsetWidth / 2,
          inset: "0px auto auto 0px"
        },
        "bottom-start": {
          top:
            window.scrollY +
            trigger?.getBoundingClientRect().y +
            trigger?.getBoundingClientRect().height +
            gap,
          left: trigger?.getBoundingClientRect().x,
          inset: "0px auto auto 0px"
        },
        "bottom-end": {
          top:
            window.scrollY +
            trigger?.getBoundingClientRect().y +
            trigger?.getBoundingClientRect().height +
            gap,
          left:
            trigger?.getBoundingClientRect().x +
            trigger?.getBoundingClientRect().width -
            tooltip?.offsetWidth,
          inset: "0px auto auto 0px"
        },
        left: {
          top:
            window.scrollY +
            trigger?.getBoundingClientRect().y +
            trigger?.getBoundingClientRect().height / 2 -
            tooltip?.offsetHeight / 2,
          left: trigger?.getBoundingClientRect().x - tooltip?.offsetWidth - gap,
          inset: "0px 0px auto auto"
        },
        "left-start": {
          top: window.scrollY + trigger?.getBoundingClientRect().y,
          left: trigger?.getBoundingClientRect().x - tooltip?.offsetWidth - gap,
          inset: "0px 0px auto auto"
        },
        "left-end": {
          top:
            window.scrollY +
            trigger?.getBoundingClientRect().y +
            trigger?.getBoundingClientRect().height -
            tooltip?.offsetHeight,
          left: trigger?.getBoundingClientRect().x - tooltip?.offsetWidth - gap,
          inset: "0px 0px auto auto"
        },
        right: {
          top:
            window.scrollY +
            trigger?.getBoundingClientRect().y +
            trigger?.getBoundingClientRect().height / 2 -
            tooltip?.offsetHeight / 2,
          left:
            trigger?.getBoundingClientRect().x +
            trigger?.getBoundingClientRect().width +
            gap,
          inset: "0px auto auto 0px"
        },
        "right-start": {
          top: window.scrollY + trigger?.getBoundingClientRect().y,
          left:
            trigger?.getBoundingClientRect().x +
            trigger?.getBoundingClientRect().width +
            gap,
          inset: "0px auto auto 0px"
        },
        "right-end": {
          top:
            window.scrollY +
            trigger?.getBoundingClientRect().y +
            trigger?.getBoundingClientRect().height -
            tooltip?.offsetHeight,
          left:
            trigger?.getBoundingClientRect().x +
            trigger?.getBoundingClientRect().width +
            gap,
          inset: "0px auto auto 0px"
        }
      };

      return placements[trigger.dataset.placement ?? "top"];
    }

    function addPosition(reference) {
      tooltip.style.position = "absolute";
      tooltip.style.transform = `translate3d(${getPlacement(reference).left}px, ${
        getPlacement(reference).top
      }px, 0px)`;
      tooltip.style.inset = "0px auto auto 0px";
      tooltip.style.margin = "0px";
    }

    trigger.forEach((trigger) => {
      const reference = trigger;
      trigger.addEventListener("mouseenter", (event) => {
        console.log('event', event);
        trigger.appendChild(tooltip);
        const content = event.target?.dataset.content;
        tooltip.innerHTML = content;
        addPosition(reference);
      });
      trigger.addEventListener("mouseleave", () => {
        tooltip.remove();
      });
    });
  }



  //MONUMENTAL-
  // we need to hide products before this initiates to avoid flashing
  function showElements() {
      const elements = document.querySelectorAll('.productgrid--items.hidden');
      for (let element of elements) {
          element.classList.remove('hidden');
      }
  }
  

  let $availability = document.querySelector('.collection-filters__filter-link[data-name="filter.v.availability"]');
  let isPageload = window.location.search.indexOf('filter.v.availability=') == -1;
  if ($availability && isPageload) { 
    $availability.click();
    $availability.dispatchEvent(new Event('input', {bubbles: true}));
  }

  setTimeout(() => {
      console.log("Script finished running!");
      showElements();
  }, 1200); // Adjust the timeout as needed
  
});

document.addEventListener('alpine:init', () => {
  console.log('alpine:init');
 

  Alpine.data('SearchProducts', () => ({
    cache: {},
    loaded: false,
    search_products: [],
    limit: 10,
    init() {
      this.InitCache();
      this.SearchProducts();
    },
    InitCache() {
      let am = this;
      am.cache.$form = am.$el.closest('form');
      am.cache.$input = am.cache.$form.querySelector('.live-search-form-field');
    },
    async SearchProducts() {
      let am = this;
      let searchTerm = am.cache.$input.value;
      // additional searches
      // 1. search for products only 
      let results_search_products = await Promise.all([
        fetch(`${window.Theme.routes.predictive_search_url}.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product`).then(res => res.json())
      ]);
      // console.log(results_search_products)

      let search_products = results_search_products.flatMap(item => item.resources.results.products).slice(0, am.limit);
      // remove duplicates
      let handles = [...new Set(search_products.map(item => item.handle))];
      let products = [];
      handles.forEach((handle) => {
        products.push(search_products.find(item => item.handle == handle));
      });
      am.loaded = true;
      am.search_products = products;
      
      console.log(products)
      setTimeout(() => {
        if (products.length > 4){
          //console.log('open the window more')
          const height = document.querySelector('.search-flydown--results').scrollHeight;
          //console.log(height);
          const search_window = document.querySelector('.search-flydown')
          search_window.style.setProperty('min-height', `${height}px`);
        }
      }, 200);
    }
  }));
});





class ProductSwiper extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="product-item-swiper-"]'); 
    this.grid_content = this.closest('.grid-product__content');
    this.grid_item = this.closest('.grid__item');
    this.gallery = this;
    this.url = this.querySelector('[data-product-url]').getAttribute('data-product-url');

    if (!this.slider) return;
    this.swiper = null; // Initialize swiper as null
    this.checkScreenSizeAndInit();
    this.initWatchers();
    this.initResizeHandler();
  }

  checkScreenSizeAndInit() {
    // Check if the screen width is 720 pixels or below
    if (window.innerWidth <= 720) {
      this.initSwiper();
    }
  }

  initWatchers() {
    document.addEventListener('variant-change', event => {
      console.log('Variant changed:', event.detail.variant);
      const varID = event.detail.variant.variant.id;
      const varUrl = `${this.url}?variant=${varID}`;
      console.log(varUrl);

      fetch(varUrl)
        .then(response => response.text())
        .then(responseText => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const gallery = responseHTML.querySelector('.product-gallery-wrap');

          // Update the gallery content
          HTMLUpdateUtility.setInnerHTML(this.gallery, gallery.outerHTML);
          console.log('Updated gallery content:', gallery.outerHTML);

          // Handle Swiper initialization based on screen size
          if (this.swiper) {
            console.log('Destroying existing Swiper');
            this.swiper.destroy(true, true);
            this.swiper = null;
          }

          // Reinitialize Swiper only if screen size is 720px or below
          if (window.innerWidth <= 720) {
            requestAnimationFrame(() => {
              this.slider = this.querySelector('[id^="product-item-swiper-"]'); // Ensure slider is updated
              console.log('Reinitializing swiper for:', this.slider.getAttribute('id'));
              this.initSwiper();
            });
          }
        });
    });
  }

  initResizeHandler() {
    window.addEventListener('resize', () => {
      // Check screen size on resize
      if (this.swiper && window.innerWidth > 720) {
        console.log('Destroying Swiper on resize to larger screen');
        this.swiper.destroy(true, true);
        this.swiper = null;
      } else if (!this.swiper && window.innerWidth <= 720) {
        console.log('Reinitializing Swiper on resize to smaller screen');
        this.initSwiper();
      }
    });
  }

  initSwiper() {
    console.log('Initiating swiper for', this.slider.getAttribute('id'));
    this.swiper = new Swiper(this.slider, {
      loop: false,
      mousewheel: {
        forceToAxis: true,
      },
      slidesPerView: 1,
      spaceBetween: 4,
      centeredSlides: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      }
    });
  }
}

customElements.define('product-photo-swiper', ProductSwiper);

//announcement swiper
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="bar-swiper-"]');
    this.speed = this.slider.dataset.speed * 1000;
    if (this.speed > 0){
      this.autoplay = true
    } else {
      this.autoplay = false
    }
    if (!this.slider) return;
    this.initSwiper();
  }

  initSwiper() {
    //console.log('announcement bar swiper')
    if(this.autoplay){
      console.log(this.speed)
      return new Swiper(this.slider, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
          delay: this.speed,
        },
          // Navigation arrows
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          }
      });
    } else {
      return new Swiper(this.slider, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
          // Navigation arrows
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          }
      });
    }
  }
}
customElements.define('announcement-bar-slider', AnnouncementBar);


class SizeChartModal extends HTMLElement {
  constructor() {
    super();
    this.triggers = this.querySelectorAll('.size-chart-trigger');
    this.modals = this.querySelectorAll('.size-chart-modal-content');
    this.activeModal = null;

    this.init();
  }

  init() {
    // Attach click event to each trigger
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', event => this.openModal(event));
    });

    // Attach close functionality to modal
    document.addEventListener('click', event => this.handleDocumentClick(event));
    document.addEventListener('keydown', event => this.handleKeydown(event));

    // Attach close functionality to each close button
    const closeButtons = this.querySelectorAll('.size-chart-close');
    closeButtons.forEach(button => {
      button.addEventListener('click', event => this.closeModal(event));
    });
  }

  openModal(event) {
    event.stopPropagation(); // Prevent the event from propagating to parent elements like the cart drawer
    const trigger = event.target;
    const chartId = trigger.getAttribute('data-chart-id');
    const modal = this.querySelector(`#${chartId}`);
    const chartCount = parseInt(trigger.getAttribute('data-chart-count'), 10);

    if (modal) {
      modal.removeAttribute('hidden');
      this.activeModal = modal;
      document.body.classList.add('no-scroll'); // Prevent background scrolling

      // If there are more than one chart, initialize the Swiper
      if (chartCount > 1) {
        this.initSwiper(modal);
      }
    }
  }

  closeModal(event) {
    // Stop the event propagation so that the document click handler doesn't close the modal
    event.stopPropagation();

    if (this.activeModal) {
      this.activeModal.setAttribute('hidden', '');
      this.activeModal = null;
      document.body.classList.remove('no-scroll');
    }
  }

  handleDocumentClick(event) {
    // Close modal if clicked outside
    if (this.activeModal && !this.activeModal.contains(event.target) && !event.target.closest('.size-chart-trigger') && !event.target.closest('.size-chart-close')) {
      this.closeModal(event);
    }
  }

  handleKeydown(event) {
    // Close modal if "Esc" key is pressed
    if (this.activeModal && event.key === "Escape") {
      this.closeModal(event);
    }
  }

  initSwiper(modal) {
    const swiperContainer = modal.querySelector('.swiper-container');
    const chartTitles = modal.getAttribute('data-chart-titles').split(','); // Get the titles from data attribute

    if (swiperContainer) {
      new Swiper(swiperContainer, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        autoHeight: true,
        simulateTouch: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: (index, className) => {
            // Use chartTitles array to create custom pagination bullets with text
            const chartTitle = chartTitles[index] || ''; // Ensure there's no undefined title
            return `<span class="${className}">${chartTitle}</span>`;
          },
        },
      });
    }
  }
}

customElements.define('size-chart-modal', SizeChartModal);






